export const DEVICE_BREAKPOINTS = {
    MOBILE: 768,
    TABLET: 1024,
    DESKTOP: 1025
} as const;

export const MEDIA_QUERIES = {
    MOBILE: '(max-width: 768px)',
    TABLET: '(min-width: 769px) and (max-width: 1024px)',
    DESKTOP: '(min-width: 1025px)'
} as const;

export const DEVICE_TYPE_NAMES = {
    MOBILE: 'mobile',
    TABLET: 'tablet',
    DESKTOP: 'desktop'
} as const;

// Legacy breakpoint constants for backward compatibility
export const LEGACY_BREAKPOINTS = {
    MOBILE: '640px',
    MOBILE_SM: '768px',
    MOBILE_MD: '989px'
} as const;

// Legacy media queries for backward compatibility
export const LEGACY_MEDIA_QUERIES = {
    MOBILE: `(max-width: ${LEGACY_BREAKPOINTS.MOBILE})`,
    MOBILE_SM: `(max-width: ${LEGACY_BREAKPOINTS.MOBILE_SM})`,
    MOBILE_MD: `(max-width: ${LEGACY_BREAKPOINTS.MOBILE_MD})`
} as const;
